import { ApplicationState } from "..";
import { ServiceCallTabs } from "./reducers";

export const getCurrentServiceCallTabId = (state: ApplicationState): ServiceCallTabs => state.ui.currentServiceCallTabId;